import { BigNumber } from 'bignumber.js'
import createDependableResource from 'utils/zustand/createDependableResource'
import { getVvsBoostAddress } from 'utils/addressHelpers'
import { getCrc20Contract } from 'utils/contractHelpers'
import { getAccount, onAccountInitOrChange } from 'state/web3/account'
import { BIG_ZERO } from 'utils/bigNumber'

interface UserBoostBalance {
  balance: BigNumber
}

const EMPTY_USER_BOOST_BALANCE: UserBoostBalance = {
  balance: BIG_ZERO,
}

const getUserBoostBalance = async (): Promise<UserBoostBalance> => {
  const account = getAccount()
  if (!account) {
    return EMPTY_USER_BOOST_BALANCE
  }

  const vvsBoostCrc20Contract = getCrc20Contract(getVvsBoostAddress())
  const balance = account ? await vvsBoostCrc20Contract.balanceOf(account) : 0

  return {
    balance: new BigNumber(balance.toString()),
  }
}

export const useUserBoostBalance = createDependableResource<UserBoostBalance>({
  initValue: EMPTY_USER_BOOST_BALANCE,
  getValue: getUserBoostBalance,
  dependResources: [],
  onInit: ({ resetValue, refresh, getIsStarted }) => {
    onAccountInitOrChange(() => {
      if (!getIsStarted()) return
      resetValue()
      refresh()
    })
  },
  dbgName: 'UserBoostBalance',
})
